<div class="flex flex-col gap-2 w-full box-border" [formGroup]="form">
    <div formArrayName="inputs" class="flex flex-col gap-2">
        @for (control of controls; track control; let index = $index) {
            <div class="flex items-center gap-1">
                <sh-input-text
                    [formControlName]="index"
                    [label]="label()"
                    [disabled]="isDisabledInternal()"
                    [error]="hasError(control)"
                    [attr.error-message]="hasError(control) ? errorMessage() : null"
                    (blur)="handleOnBlur()"
                    class="flex-1"
                    [attr.no-border]="noBorder() ? true : null"
                >
                    @if (showScdPicker() && isInternalUser()) {
                        <sh-icon
                            icon="user"
                            button
                            slot="icon"
                            state="showhide"
                            size="s"
                            (click)="openScdPicker(index)"
                            title="Look up user"
                        ></sh-icon>
                    }
                    @if (index > 0 && !isDisabledInternal()) {
                        <sh-icon
                            icon="delete"
                            button
                            slot="icon"
                            state="showhide"
                            (click)="removeInput(index)"
                        ></sh-icon>
                    }
                </sh-input-text>
                @if (layout() === 'horizontal' && index === controls.length - 1 && !isDisabledInternal()) {
                    <sh-icon
                        icon="plus-light"
                        button
                        [attr.aria-label]="addButtonLabel()"
                        (click)="addInput()"
                    ></sh-icon>
                }
            </div>
        }
    </div>

    @if (layout() !== 'horizontal' && !isDisabledInternal()) {
        <div class="mt-2">
            <sh-button
                [label]="addButtonLabel()"
                icon="plus"
                icon-position="left"
                color="secondary"
                size="max-content"
                (click)="addInput()"
                [disabled]="isDisabledInternal()"
            ></sh-button>
        </div>
    }
</div>
